import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(({ icon, palette }) => ({
    badge: {
        top: -4,
        right: -2,
    },
    checkListIcon: {
        color: icon.color,
        stroke: icon.stroke,
    },
    iconDisable: {
        fill: palette.type === 'light' ? palette.grey['300'] : palette.grey[900],
    },
    iconWarning: {
        fill: palette.warningColor,
    },
    iconReady: {
        fill: '#4CAF50',
    },
    listIcon: {
        minWidth: '40px',
    },
    statusSend: {
        fill: '#4CAF50',
    },
    statusEdit: {
        fill: '#40C4FF',
    },
}));
